import Send from "../communication";
import { buildQueryParams } from "../utils/dateUtils";

export const getContentsSent = async (user = "", scope, scopeType, currentUser) => {
  const queryParams = buildQueryParams(user, false, scopeType, false, currentUser);
  const query = `/dw/data/content/project/${scope?.id}`
  return await Send.get(query, queryParams);
};